import { CommonModule } from '@angular/common';
// This Module's Components
import { HttpClientModule } from '@angular/common/http';
// Angular Imports
import { NgModule } from '@angular/core';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { AcctactvtyModule } from '../acctactvty/acctactvty.module';
import { FlyoutFeedComponent } from './flyout-feed.component';

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    AcctactvtyModule,
    ModalModule.forRoot(),
    TabsModule.forRoot()
  ],
  declarations: [FlyoutFeedComponent],
  exports: [FlyoutFeedComponent]
})
export class FlyoutFeedModule {}
